import * as httpUtil from "@/utils/httpUtil";

const interfaces: Array<Record<string, any>> = [
  {
    //desc: "获取气泡数据",
    method: "post",
    name: "getBubbleData",
    url: "/sysmenu/getBubbleData",
  },
  {
    //desc: "清除气泡数量",
    method: "post",
    name: "clearBubbleCount",
    url: "/sysmenu/clearBubbleCount",
  },
  {
    //desc: "问题管理模块的分页查询",
    method: "post",
    name: "pageQuestionManage",
    url: "/community/question/pageQuestionManage",
  },
  {
    //desc: "问题管理模块的分页查询",
    method: "post",
    name: "pageQuestionList",
    url: "/community/question/pageQuestionList",
  },
  {
    //desc: 获取登录客户可控制的系统菜单",
    method: "get",
    name: "getSysMenuByCommunity",
    url: "/sysmenu/V2/getSysMenuByCommunity",
  },
  {
    //desc: 获取登录客户可控制的系统菜单",
    method: "post",
    name: "getSysMenuByHealthServiceProject",
    url: "/sysmenu/getSysMenuByHealthServiceProject",
  },

  {
    //desc: 检查是否发放过基因服务",
    method: "post",
    name: "isEverSetStateByCommunityId",
    url: "/c/pc/quickServiceCommunity/community/isEverSetStateByCommunityId",
  },
  {
    //desc: 查询社区详情-new",
    method: "get",
    name: "getCommunityDetail",
    url: "/community/findCommunityDetail",
  },
  {
    //desc: 上架/下架诊室",
    method: "post",
    name: "getPlaceList",
    url: "/doctor/consultation/getPlaceList",
  },
  {
    //desc: 用户信息",
    method: "get",
    name: "myinfo",
    url: "/bcustomer/myInfo",
  },
  {
    //desc: 社区信息",
    method: "get",
    name: "queryOrgDetail",
    url: "/organization/queryOrgDetail",
  },
  {
    //desc: "图片上传",
    method: "postFile",
    name: "uploadImg",
    url: "/file/uploadImg",
  },
  {
    //desc: "多文件上传",
    method: "postFile",
    name: "uploadFiles",
    url: "/file/uploadFiles",
  },
  {
    //desc: "文件上传",
    method: "postFile",
    name: "uploadFile",
    url: "/file/uploadFile",
  },
  {
    //desc: "获取社区配置",
    method: "post",
    name: "getCommunityConfig",
    url: "/community/config/getCommunityConfig",
  },
  {
    //desc: "获取社区配置",
    method: "post",
    name: "getUnReadMessageNumber",
    url: "/message/getUnReadMessageNumber",
  },
  {
    //desc: "获取社区配置",
    method: "post",
    name: "findMessageList",
    url: "/c/pc/common/message/findMessageList",
  },
  {
    //desc: "获取社区分类列表",
    method: "post",
    name: "pageCategory",
    url: "/medicine/category/pageCategory",
  },
  {
    //desc: "根据id查分类",
    method: "post",
    name: "categoryGetById",
    url: "/medicine/category/getById",
    // config: { ignoreError: true },
  },
  {
    //desc: "检索标签",
    method: "post",
    name: "getContentLabelInfoList",
    url: "/community/content/label/getContentLabelInfoList",
  },
  {
    //desc: "检索标签",
    method: "post",
    name: "getContentLabelInfo",
    url: "/community/content/label/getContentLabelInfo",
  },
  {
    //desc: "新增标签,
    method: "post",
    name: "addContentLabel",
    url: "/community/content/label/addContentLabel",
  },
  {
    //desc: "新增/编辑 专题/文章类型",
    method: "post",
    name: "saveCategory",
    url: "/medicine/category/saveCategory",
  },
  {
    //desc: "获取科室",
    method: "get",
    name: "queryTreeList",
    url: "/department/queryTreeList",
  },
  {
    //desc: "中台科室接口",
    method: "get",
    name: "findDepartmentHierarchyList",
    url: process.env.VUE_APP_DEPARTMENTlIST + "/department/findDepartmentHierarchyList",
  },
  {
    //desc: "获取科室",
    method: "get",
    name: "getDepList",
    url: "/department/getDepList",
  },
  {
    //desc: "获取执业类型列表",
    method: "post",
    name: "getPractisingTypeList",
    url: "/communityCustomer/getPractisingTypeList",
  },
  {
    //desc: "查询授信用户，认证用户, 未授信未认证用户科室",
    method: "post",
    name: "getActivityUserDepts",
    url: "/department/getActivityUserDepts",
  },
  {
    //desc: "获取账户信息",
    method: "get",
    name: "getBalanceInfo",
    url: "/finance/balanceInfo",
  },
  {
    //desc: "医生分页列表",
    method: "post",
    name: "queryDoctorPageList",
    url: "/communityCustomer/queryDoctorPageList",
  },
  {
    //desc: "查询医生列表",
    method: "post",
    name: "queryDoctorList",
    url: "/communityCustomer/queryDoctorList",
  },
  {
    //desc: "科普直播列表",
    method: "post",
    name: "getLivePage",
    url: "/medicine/communityLive/getLivePage",
  },
  {
    //desc: "分页查询文章接口",
    method: "post",
    name: "pageArticleByTitle",
    url: "/medicine/article/pageArticleByTitle",
  },
  {
    //desc: "微博账户列表",
    method: "post",
    name: "getCommunityBindWeiboList",
    url: "/weibo/getCommunityBindWeiboList",
  },
  {
    //desc: "获取公众号详情列表",
    method: "post",
    name: "getWeChatDetails",
    url: "/third/wechat/getWeChatDetails",
  },
  {
    //desc: "微博分享",
    method: "post",
    name: "weiboSharePush",
    url: "/share/weiboSharePush",
  },
  {
    //desc: "授权医生微博分享",
    method: "post",
    name: "doctorShareArticle2Weibo",
    url: "/share/doctorShareArticle2Weibo",
  },
  {
    //desc: "微信分享",
    method: "post",
    name: "sharePushWeChatArticle",
    url: "/share/sharePushWeChatArticle",
  },
  {
    //desc: "问题邀约详情",
    method: "post",
    name: "findQuestionDetailById",
    url: "/community/question/findQuestionDetailById",
  },
  {
    //desc: "文章详情",
    method: "post",
    name: "getArticleInfo",
    url: "/medicine/article/getArticleInfo",
  },
  {
    //desc: "帖子详情",
    method: "get",
    name: "getPostDetail",
    url: "/postbar/posts/getPostInfoById",
  },
  {
    //desc: "话题详情",
    method: "get",
    name: "getTopicDetail",
    url: "/postbar/topic/findById",
  },
  {
    //desc: "落地页详情",
    method: "post",
    name: "getLandingPageConfig",
    url: "/community/landingPage/config/getLandingPageConfig",
  },

  {
    //desc: "问卷详情",
    method: "post",
    name: "getQuestionnaire",
    url: "/questionnaire/getQuestionnaire",
  },

  {
    //desc: "表情",
    method: "post",
    name: "getWeiboEmotions",
    url: "/share/getWeiboEmotions",
  },
  {
    //desc: "用户角色",
    method: "get",
    name: "findCurrentComtyRole",
    url: "/account/findCurrentComtyRole",
  },
  {
    //desc: "视频分片上传",
    method: "postFile",
    name: "videoUpload",
    url: "/upload/v1/files/upload",
  },
  {
    //desc: "上传视频文件初始化",
    method: "postFile",
    name: "videoUploadInit",
    url: "/upload/v1/files/upload_init",
  },
  {
    //desc: "上传视频触发合成字幕",
    method: "post",
    name: "mpsTranscodeAddSubtitle",
    url: `${process.env.VUE_APP_B_HEALTH_LINK}/middle-sp/video/api/mpsTranscodeAddSubtitle`,
  },
  {
    //desc: "ststoken",
    method: "get",
    name: "getUploadBySts",
    url: `${process.env.VUE_APP_B_HEALTH_LINK}/middleoos/api/file/open/getUploadBySts`,
  },
  {
    //desc: "ststoken",
    method: "get",
    name: "externalGetUploadBySts",
    url: `${process.env.VUE_APP_B_EXTERNAL_HEALTH_LINK}/middleoos/api/file/open/getUploadBySts`,
  },
  {
    method: "post",
    name: "batchAssignClass",
    url: "/medicine/article/batchAssignClass",
  },
  {
    method: "post",
    name: "batchAssignLabel",
    url: "/medicine/article/batchAssignLabel",
  },
  {
    //desc: "发布者成员列表",
    method: "post",
    name: "queryPage",
    url: "/account/queryPage",
  },
  {
    //desc: "职称列表",
    method: "get",
    name: "professionInfo",
    url: "/activity/professionInfo",
  },
  {
    //desc: "马甲号",
    method: "post",
    name: "getVirtualCounter",
    url: "/virtualAccount/getSelectPageInfo",
  },
  {
    //desc: "商品列表分页",
    method: "post",
    name: "getGoodsListApi",
    url: "/medicalbeauty/goodsManager/findPage",
  },
  {
    //desc: "据社区id查审最近一次的核状态和信息",
    method: "get",
    name: "findCommunityAudit",
    url: "/community/findCommunityAudit",
  },
  {
    method: "post",
    name: "phoneResister",
    url: "/midauth/pubuserInfo/phoneResister",
  },
  {
    //desc: "失败模板下载",
    method: "getExFile",
    name: "exportFailExcelApi",
    url: "/credit/user/exportFailExcel",
  },
  {
    //desc: "新线索声音提示 查询指定时间范围内 是否有新线索      ",
    method: "post",
    name: "saasNewLeadTip",
    url: "/medicalbeauty/commonLead/saasNewLeadTip",
  },
  {
    //desc: "预约通菜单权限      ",
    method: "post",
    name: "orgAuthority",
    url: "/medicalbeauty/commonLead/orgAuthority",
  },
  {
    //desc: "获取文章医生微博授权",
    method: "post",
    name: "getDoctorBindWeiboInfo",
    url: "/weibo/getDoctorBindWeiboInfo",
    config: { ignoreError: true },
  },
  {
    method: "post",
    name: "getDictionaryTree",
    url: `${process.env.VUE_APP_DEPARTMENTlIST}/dict/getDictionaryTree`,
    desc: "省市区",
  },
  {
    method: "post",
    name: "sendSmsNew",
    url: "/midauth/pubuserInfo/v2/sendSmsNew", // 发送手机验证码-校验行为验证码场景
  },
  {
    //desc: "根据关键词搜索医院列表",
    method: "post",
    name: "getHospitalByKeyWord",
    url: "/c/pc/community/doctor/auditRecord/getHospitalByKeyWord",
  },

  {
    //desc: "根据医院名称/省市区查询医院库信息",
    method: "post",
    name: "getHospitalListByPcaOrName",
    url: "/c/pc/community/doctor/auditRecord/getHospitalListByPcaOrName",
  },
];

function exportsRender(interfacesArr: Array<Record<string, any>>) {
  const resultExports: Record<string, any> = {};
  interfacesArr.map((item: Record<string, any>) => {
    resultExports[item.name] = (data: Record<string | number, any>) => {
      return (httpUtil as Record<string, any>)[item.method](item.url, data, item.config);
    };
  });
  return resultExports;
}

export default exportsRender(interfaces);
